import request from '../util/request'

/**
 * header 数据集
 */
export function getCompositeIndex () {
  return request({
    url: '/api/getCompositeIndex',
    method: 'GET'
  })
}

/**
 * 获取物流公司金额时间
 */
export function getCompany () {
  return request({
    url: '/api/getCompany',
    method: 'GET'
  })
}

/**
 * 获取每日交易额/订单数
 */
export function getDailyTradingVolume () {
  return request({
    url: '/api/getDailyTradingVolume',
    method: 'GET',
    params: {
      a: false
    }
  })
}

/**
 * 获取线路金额
 */
export function getLine () {
  return request({
    url: '/api/getLine',
    method: 'GET'
  })
}

/**
 * 我要找车 
 */
export function getModelUsage () {
  return request({
    url: '/api/getModelUsage',
    method: 'GET'
  })
}

/**
 * 干线前十
 */
export function getGX () {
  return request({
    url: '/api/getGX',
    method: 'GET'
  })
}

/**
 * 支线前十
 */
export function getZX () {
  return request({
    url: '/api/getZX',
    method: 'GET'
  })
}

/**
 * 城配前十
 */
export function getCP () {
  return request({
    url: '/api/getCP',
    method: 'GET'
  })
}

/**
 * 仓储前十
 */
export function getCC () {
  return request({
    url: '/api/getCC',
    method: 'GET'
  })
}


/**
 * 获取物品类型占比
 */
export function getType () {
  return request({
    url: '/api/getType',
    method: 'GET'
  })
}
